
(function roleModifyControllerDefinition() {
    'use strict';

    angular.module('Role')
        .controller('RoleModifyController', [
            '$scope', 'config', '$state', '$translate', '$stateParams', 'errorsExtend', 'adminRoleService', 'authExtend', 'auth', 'functionService',
            function roleModifyController($scope, config, $state, $translate, $stateParams, errors, adminRoleService, authExtend, auth, functionService) {
                $scope.canAssociateAd = auth.isInRole('ROLES ASSOCIATE AD');
                $scope.allApps = authExtend.isInRole('CONFIG ADMIN APPS');
                $scope.title = 'RoleModify';
            
                if ($scope.allApps) {
                    functionService.getApps().then(function getOk(result) {
                        $scope.optionApps = result;
                    }, function getError(error) {
                        errors.showError(error);
                    });
                }


                $scope.requiredOu = authExtend.getOrganizationId() ? true : false;

                adminRoleService.getById($stateParams.id).then(function (result) {
                    $scope.role = result;
                    $scope.role.application = {
                        id: result.applicationId
                    };

                }, function (error) {
                    errors.showError(error);
                    $state.go('role-find');
                });

                $scope.cancel = function () {
                    $state.go('role-find');
                };

                $scope.save = function () {
                    if (!$scope.roleForm.$valid) {
                        errors.showError('VerifyFormData');
                        $scope.roleForm.$setSubmitted();
                        return false;
                    }

                    if ($scope.role.application) {
                        $scope.role.applicationId = $scope.role.application.id;
                    }

                    return adminRoleService.modify($scope.role).then(function () {
                        $state.go('role-functions', { id: $scope.role.id });
                    },
                        function (error) {
                            errors.showError(error);
                        });
                };
            }
        ]);
})();